module.exports = __webpack_public_path__ + "static/media/sound_1.70860b47.mp3";